/**
 * Lightweight tenant user directory, shared by the collaboration surfaces
 * (Company Feed, Messages, Workgroups, Time Clock, Surveys). The backend
 * `/users` list exposes no display name, so the directory resolves a friendly
 * label from the email local-part, falling back to a short id.
 */

import { apiClient } from '@/lib/apiClient';

export interface DirectoryUser {
  id: string;
  email: string;
  role: string;
  status: string;
}

export async function listDirectoryUsers(): Promise<DirectoryUser[]> {
  const { data } = await apiClient.get<DirectoryUser[]>('/users');
  return data;
}

/** Friendly label for a user id given a directory map. */
export function displayName(
  users: Map<string, DirectoryUser>,
  id: string | null | undefined,
): string {
  if (!id) return '—';
  const u = users.get(id);
  if (!u) return id.slice(0, 8);
  const local = u.email.split('@')[0];
  return local || u.email;
}
